import React, { useState } from "react";

import { Button } from "@samskip/frontend-components";
import { useTranslation } from "react-i18next";

import World from "@assets/images/icons/world.inline.svg";

import Menu from "./menu";

interface OutsideLink {
  id: string;
  href: string;
  title: string;
}
const outsideLinks: OutsideLink[] = [
  {
    id: "link-1",
    href: "http://www.samskip.is",
    title: "SAMSKIP.IS",
  },
  {
    id: "link-2",
    href: "http://www.samskip.com",
    title: "SAMSKIP.COM",
  },
];

const WebsitesMenu = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen((oldVal) => !oldVal);
  };

  return (
    <div>
      <Button
        className="uppercase"
        color="neutral-700"
        onClick={toggleOpen}
        variant="text"
      >
        <div className="flex items-center gap-1.5">
          <World className="text-primary" />
          {t("LABEL_OUR_SITES")}
          <b className="ml-0.5 border-t-4 border-t-neutral-700 border-x-4 border-x-transparent inline-block w-0 h-0" />
        </div>
      </Button>
      <Menu isOpen={isOpen}>
        {outsideLinks.map((outsideLink) => (
          <Menu.Item href={outsideLink.href} key={outsideLink.id} size="small">
            {outsideLink.title}
          </Menu.Item>
        ))}
      </Menu>
    </div>
  );
};

export default WebsitesMenu;
